// Elite
export default [
    {type: "freeplay", to: "$10"},
    {type: "weekly_rakeback", to: "20%"},
    {type: "monthly_rakeback", to: "15%"},
    {type: "birthday_bonus", to: "$50 + 20%"},
    {type: "deposit_assist_token", to: "$2.5"}
]